import { render } from "./AssignUnitPage.vue?vue&type=template&id=4d7da512"
import script from "./AssignUnitPage.vue?vue&type=script&lang=js"
export * from "./AssignUnitPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__